import { BitMask } from './BitMask';

export enum BetAcceptedEventBitMaskTypes {
  FreebetsOn = 0b00000001,
  AutplayOn = 0b00000010,
  SubtitlesOn = 0b00000100,
}

export const BetAcceptedEventBitMask = new BitMask<BetAcceptedEventBitMaskTypes>();
